import { FoodsSelect } from "@foodpilot/foods";
import { useState } from "react";
import { CommonPropertyProps } from "./_common";
import { Stack, useTheme } from "@mui/material";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { determineCalculationType } from "./formulaUtils";
import { getOptionCodes } from "src/utils/dataListOptions";

type SelectProps = CommonPropertyProps;
export const Select = (props: SelectProps) => {
    const theme = useTheme();
    const { ssqVersion } = useActionsContext();
    const { property, value: initialValue, updatePropertyValue, disabled } = props;

    const options = property.dataList?.options;

    const [selectedValue, setSelectedValue] = useState(initialValue);

    return (
        <Stack flexDirection={"row"} alignItems={"center"} gap={theme.spacing(2)}>
            <FoodsSelect
                selectedOption={
                    options?.find((option) => option.code === selectedValue) ??
                    options?.find((option) => option.value === selectedValue) ??
                    null
                }
                options={options ?? []}
                onChange={(newValue) => {
                    if (newValue !== null) setSelectedValue(newValue.code);

                    // Déterminer le type de calcul approprié
                    const calculationType = determineCalculationType(ssqVersion, property.id, true);

                    updatePropertyValue({
                        serializedString: newValue?.value ?? "",
                        dataListOptionCodes: newValue ? getOptionCodes([newValue]) : [],
                        calculationType,
                    });
                }}
                disabled={disabled}
                getId={(option) => option.id}
                getName={(option) => option.label}
                textOptions={{
                    placeholder: "",
                    searchPlaceholder: "",
                    emptyOptionsText: "",
                    defaultValueText: undefined,
                    noResult: "",
                }}
            />
        </Stack>
    );
};
